import { z } from 'zod';
import { ProjectTagIdSchema } from '../dto/ProjectTags.js';
import { ResearchDataEventBaseSchema } from './common.js';
export const ProjectTagAttachedEventSchema = ResearchDataEventBaseSchema.extend({
    subject: z.literal('research-data.project.tag-attached'),
    action: z.literal('tag-attached'),
    data: z
        .object({
        projectId: z.string().guid(),
        tagId: ProjectTagIdSchema,
    })
        .strict(),
}).strict();
//# sourceMappingURL=ProjectTagAttached.js.map